import { render, staticRenderFns } from "./LaAdvertising.vue?vue&type=template&id=4f07f976&scoped=true&"
import script from "./LaAdvertising.vue?vue&type=script&lang=js&"
export * from "./LaAdvertising.vue?vue&type=script&lang=js&"
import style0 from "./LaAdvertising.vue?vue&type=style&index=0&id=4f07f976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f07f976",
  null
  
)

export default component.exports